export default __webpack_public_path__ + "static/media/616.8f53a488.jpg";